import React, { Component } from 'react'
import { Form, InputNumber, Tooltip, Button, Popconfirm, message, Select } from 'antd';
import ModalDom from '../../../../components/Modal';
import { config, postFrom } from '../../../../axios';

const Option = Select.Option

class Choose extends Component {
  constructor(props) {
    super()

    this.state = {
      loading: false,
      data: [],
      list: [],
      title: '客户签约',
      visible: false,
    }

    this.initSingleData = { // 单条数据
      key: 0,
      name: '',
      dicValue: '',
      num: 1
    }
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  handleDelete = (index) => { // 删除
    const { data } = this.state
    data.splice(index, 1)
    this.setState({ data })
  }

  handleAdd = () => { // 添加
    const { data, list } = this.state
    const len = data.length
    if (len) {
      data.push({
        key: data[len - 1].id,
        name: list[len] ? list[len].dicValue : '',
        dicValue: list[len] ? list[len].dicValue : '',
        num: 1
      })
    } else {
      data.push(this.initSingleData)
    }
    this.setState({ data })
  }

  handleOk = () => { // 确定
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        let valueKeys = Object.keys(values);
        valueKeys = valueKeys.filter((item, index) => {
            if (/^name_[\d]+$/.test(item)) return item;
        })
        let dataList = valueKeys.map((item, index) => {
            let num = item.split('_')[1];
            let name = values[`name_${num}`];
            item = {
                key: num,
                name,
                num: values[`num_${num}`],
            };
            return item
        });
        this.setState({ visible: false, data: [] })
        this.resolve(dataList)
      }
    })
  }

  handleCancel = () => { // 关闭
    this.setState({ visible: false })
  }

  postFindAll(groupName) { // 获取下拉列表
    postFrom({
      url: config.API_dictionary_findList,
      data: { groupName }
    }).then(res => {
      this.setState({ list: res })
    }).catch(err => {
      message.error(err.message || '获取数据失败');
    })
  }

  onShow = (type, data = []) => { // 外部调用
    this.setState({
      visible: true,
      title: type,
      data
    })
    this.postFindAll(type)
    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { visible, loading, data, title, list } = this.state
    const { handleOk, handleCancel, handleAdd, handleDelete } = this

    return (
      <ModalDom
        width="500px"
        title={title}
        loading={loading}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="custom">
          <Form>
            <div className="tableBox">
              <div className="tableTitle">
                <div style={{ flex: 1 }} className="xinxin xinxinColor">名称</div>
                <div style={{ flex: 1 }} className="xinxin xinxinColor">数量</div>
                <div style={{ flex: '0 0 100px' }}>操作</div>
              </div>
              <div className="tableBody">
                {
                  data.map((item, index) => {
                    return (
                      <div className="tableBodyRow" key={item.key}>
                        <div style={{ flex: 1, alignItems: 'center' }}>
                          {getFieldDecorator(`name_${index + 1}`, {
                            rules: [{
                                required: true, message: '请输入',
                            }],
                            initialValue: item.name ? item.name : (list.length ? list[0].name : undefined)
                          })(
                            <Select
                                showSearch
                                placeholder="请选择"
                                optionFilterProp={'children'}
                            >
                                {list.map((item, index) => <Option value={item.dicValue} key={index}>{item.dicValue}</Option>)}
                            </Select>
                        )}
                        </div>
                        <div style={{ flex: 1 }}>
                          {getFieldDecorator(`num_${index + 1}`, {
                              rules: [{
                                  required: true, message: '请输入',
                              }],
                              initialValue: item.num ? item.num : 1
                          })(
                              <InputNumber
                                min="1"
                                max="7"
                                className="XADSD-1"
                              />
                          )}
                        </div>
                        <div style={{ flex: '0 0 100px' }}>
                          <Popconfirm
                              placement="topRight"
                              title={'此删除操作不可恢复，确定删除吗？'}
                              onConfirm={() => { handleDelete(index) }}
                              okText="删除"
                              cancelText="取消"
                          >
                              <span className="showClickDetail">删除</span>
                          </Popconfirm>
                        </div>
                      </div>
                    )
                  })
                }

                <div className="tableBodyRow" style={{ justifyContent: 'center', alignItems: 'center', height: '40px' }}>
                  <Tooltip placement="bottomLeft" title={"添加一行输入框"}>
                      <Button onClick={handleAdd} style={{ width: '24px', height: '24px', textAlign: 'center', lineHeight: '16px', fontSize: '14px' }} shape="circle" icon="plus" />
                  </Tooltip>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <style>
          {`
            .XADSD-1 .ant-input-number-input{
              text-align: center;
            }
          `}
        </style>

      </ModalDom>
    )
  }
}

export default Form.create()(Choose);


// WEBPACK FOOTER //
// ./src/page/RentContract/components/TemplateUpdate/Choose.jsx